import { useSvgParsedStyle } from '@/_shared/hooks/useSvgParsedStyle';
import { SvgProps } from '@/_shared/types/svg';

export const Folder = ({ style }: SvgProps) => {
  const { primaryColorToUse, heightToUse, widthToUse } = useSvgParsedStyle({
    defaultWidth: '24',
    defaultHeight: '24',
    style,
  });

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={widthToUse}
      height={heightToUse}
      fill='none'
      viewBox='0 0 24 24'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M1.87868 2.87868C2.44129 2.31607 3.20435 2 4 2H7.93C8.42666 2.00008 8.9157 2.12347 9.35291 2.35909C9.7883 2.59373 10.1589 2.93236 10.4317 3.34479L11.2453 4.55001C11.3372 4.6897 11.4627 4.80412 11.6103 4.88274C11.758 4.96135 11.923 5.00169 12.0902 5.00005L12.1 4.99995L20 5C20.7957 5 21.5587 5.31607 22.1213 5.87868C22.6839 6.44129 23 7.20435 23 8V18C23 18.7957 22.6839 19.5587 22.1213 20.1213C21.5587 20.6839 20.7957 21 20 21H4C3.20435 21 2.44129 20.6839 1.87868 20.1213C1.31607 19.5587 1 18.7957 1 18V5C1 4.20435 1.31607 3.44129 1.87868 2.87868ZM4 4C3.73478 4 3.48043 4.10536 3.29289 4.29289C3.10536 4.48043 3 4.73478 3 5V18C3 18.2652 3.10536 18.5196 3.29289 18.7071C3.48043 18.8946 3.73478 19 4 19H20C20.2652 19 20.5196 18.8946 20.7071 18.7071C20.8946 18.5196 21 18.2652 21 18V8C21 7.73478 20.8946 7.48043 20.7071 7.29289C20.5196 7.10536 20.2652 7 20 7H12.1044C11.6045 7.004 11.1115 6.88302 10.6703 6.64802C10.2292 6.41316 9.85389 6.07187 9.57826 5.65519L8.76478 4.45004C8.67373 4.31177 8.54982 4.19824 8.40408 4.1197C8.2584 4.04118 8.0955 4.00005 7.93 4C7.92994 4 7.93005 4 7.93 4H4Z'
        fill={primaryColorToUse}
      />
    </svg>
  );
};
